import { Component, Input } from '@angular/core';
import { HeaderMenuItem } from '~components/header-menu-item/header-menu-item.component';

@Component({
  selector: 'header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent {
  @Input()
  public readonly menuItems: HeaderMenuItem[];

  public activeMenuItem: string = '';

  constructor() {}

  public isMenuItemActive(id: string): boolean {
    return this.activeMenuItem === id;
  }

  public onToggleMenuItem(id: string): void {
    if (this.activeMenuItem === id) {
      this.activeMenuItem = '';
    } else {
      this.activeMenuItem = id;
    }
  }
}
